<template>
  <b-card-group deck columns>
    <b-card>
      <template #header>
        <small class="text-muted">就业资讯</small>
      </template>
      <b-row class="news-list mb-1" v-for="(item, index) in policyList" :key="index">
        <b-col cols="9" class="text-truncate">
          ■ <b-link :to="'/show-info/' + item.contentId" target="_self" class="news-list">{{ item.contentTitle }}</b-link>
        </b-col>
        <b-col class="text-truncate">{{ item.createTime }}</b-col>
      </b-row>
      <b-card-text class="text-right">
        <b-link to="/info-main" target="_self" class="news-list">更多>>></b-link>
      </b-card-text>
    </b-card>
    <b-card>
      <b-carousel
        id="carousel-1"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide v-for="(item, index) in adList" :key="index">
          <template #img>
            <img class="d-block scroll-img" :src="item.pic" :alt="item.title" />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  name: 'SecondZone',
  data() {
    return {
      // 轮播广告图列表
      adList: undefined,
      // 就业资讯列表
      policyList: undefined
    }
  },
  mounted: function () {
    this.fetchAdList()
    this.fetchPolicyList()
  },
  methods: {
    /**
     * 获取广告列表
     */
    fetchAdList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/scroll-chart-list',
          data: postData
        })
        .then((d) => {
          this.adList = d
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取广告列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取就业资讯列表
     */
    fetchPolicyList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/policy-list',
          data: postData
        })
        .then((d) => {
          this.policyList = d.records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取就业资讯列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    onSlideStart() {},
    onSlideEnd() {}
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  font-size: 14px;
}
.scroll-img {
  height: 388px;
  width: 530px;
}
</style>
